export class EventEmitter {
    _events;
    constructor() {
        this._events = {};
    }
    /**
     * Subscribe to an event by its name.
     * @param {string }eventType - The name of the event to subscribe to.
     * @param {any} fn - The handler called when the event occurs.
     */
    on(eventType, fn) {
        this._events[eventType] = this._events[eventType] || [];
        this._events[eventType].push(fn);
        return;
    }
    /**
     * Unsubscribe from an event by its name.
     * @param {string} eventType - The name of the event to subscribe to.
     * @param {any} fn - The handler to remove.
     */
    off(eventType, fn) {
        if (!eventType) {
            this._events = {};
            return;
        }
        if (this._listens(eventType)) {
            const index = this._events[eventType].indexOf(fn);
            if (index >= 0) {
                this._events[eventType].splice(index, 1);
            }
            if (!this._events[eventType].length) {
                delete this._events[eventType];
            }
        }
        return;
    }
    fire(eventType, data) {
        if (!this._listens(eventType)) {
            return;
        }
        for (const fn of this._events[eventType]) {
            fn.call(this, data);
        }
        return;
    }
    _listens(eventType) {
        return eventType in this._events;
    }
}
//# sourceMappingURL=EventEmitter.js.map